export function readTrackingParam(name) {
    if (typeof window.getTrackingParam === "function") {
        return window.getTrackingParam(name) ?? "";
    }
    return "";
}
